import { createActions, createReducer } from 'reduxsauce'

import VencedoresLicitacaoService from '../../servicos/VencedoresLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaVencedoresLicitacaoInicio: [],
    buscaVencedoresLicitacaoSucesso: ['vencedoresLicitacao'],
    buscaVencedoresLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaVencedoresLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaVencedoresLicitacaoInicio())
        let serv = new VencedoresLicitacaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaVencedoresLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaVencedoresLicitacaoErro(error)))
    }
}

const buscaVencedoresLicitacaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaVencedoresLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaVencedoresLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.vencedoresLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_VENCEDORES_LICITACAO_INICIO]: buscaVencedoresLicitacaoInicio,
    [Types.BUSCA_VENCEDORES_LICITACAO_ERRO]: buscaVencedoresLicitacaoErro,
    [Types.BUSCA_VENCEDORES_LICITACAO_SUCESSO]: buscaVencedoresLicitacaoSucesso,
})
